export default __webpack_public_path__ + "static/media/IC.ecba0db3.svg";